import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import MyAccountCompanySearchForm from './MyAccountCompanySearchForm.component';

/** @namespace PeggysagePwa/Component/MyAccountCompanySearchForm/Container */
export class MyAccountCompanySearchFormContainer extends PureComponent {
    static propTypes = {
        onSkip: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired
    };

    containerFunctions = {
        onZipcodeChange: this.onZipcodeChange.bind(this),
        validateZipcodeField: this.validateZipcodeField.bind(this),
        onSuggestionSelected: this.onSuggestionSelected.bind(this),
        onSkip: this.onSkip.bind(this),
        onSubmit: this.onSubmit.bind(this)
    };

    state = {
        currentZipcode: '',
        isCompanyFieldDisabled: true,
        isSubmitDisabled: true,
        companyDetails: {}
    };

    containerProps() {
        const { currentZipcode, isCompanyFieldDisabled, isSubmitDisabled } = this.state;

        return {
            currentZipcode,
            isCompanyFieldDisabled,
            isSubmitDisabled
        };
    }

    onZipcodeChange(event, field) {
        const { value: zipCode = '' } = field || {};
        this.setState({ currentZipcode: zipCode });
    }

    validateZipcodeField(value) {
        // eslint-disable-next-line
        const fieldLength = 5;

        if (value.length !== fieldLength) {
            return __('Minimum %s characters!', fieldLength);
        }

        if (['97', '98'].includes(value.substr(0, 2))) {
            return __('Les entreprises domiciliées à Monaco ou aux Dom-Tom ne peuvent pas créer de compte pro');
        }

        return true;
    }

    onSuggestionSelected(event, { suggestion }) {
        this.setState({
            companyDetails: suggestion,
            isSubmitDisabled: false
        });
    }

    onSkip() {
        const { onSkip } = this.props;

        onSkip();
    }

    onSubmit(e) {
        const { onSubmit } = this.props;
        const { companyDetails } = this.state;

        onSubmit(e, { companyDetails });
    }

    render() {
        return (
            <MyAccountCompanySearchForm
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default MyAccountCompanySearchFormContainer;
